export default __webpack_public_path__ + "assets/images/11a4fd962ddc5078a0308119315ddc8f.png";